import React from 'react'
import { createRoot } from 'react-dom/client'
import { sessionService } from 'utils/sessionService'
import App from './components/App'
import createStore from 'store/createStore'
import { Provider } from 'react-redux'

const store = createStore(window.__INITIAL_STATE__)

sessionService.initSessionService(store)

// Render Setup
const MOUNT_NODE = document.getElementById('root')

const root = createRoot(MOUNT_NODE)

root.render(
  <Provider store={store}>
    <App store={store} />
  </Provider>
)
